

































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Store } from 'vuex';
import Nodes  from './nodes.vue';
import  Sidebars  from './sidebar.vue';
import GeneralService from "@/services/general-service";

import '../styles/headers.scss';
import config from '../services/api-config';
import AuthService from '../services/auth-service';

export interface IMenu {
  name: string;
  icon: string;
  route: string;
  caption: string;
  isVisable: boolean;
  children: Array<IMenu>
}

@Component({
  name: "navigation",
  components: { 'nodes': Nodes, 'sidebar': Sidebars },
  props: ['active', 'isAdmin']
})
export default class AreaNavigation extends Vue {
  private auth = new AuthService();
  private getStatus= new GeneralService();
  private user = {displayName: localStorage[config.currentUser] !== undefined ? JSON.parse(localStorage[config.currentUser]) : ''};
  private lastName = "";
  private isLastName = true;
  emailNotification=false;
  active: boolean;
  isAdmin: boolean;
  private notExpand: boolean = false;

  mounted() {
    const width = window.screen.width;
    (this.$parent as any).active = width < 800 || !this.isAdmin ? false : this.active;
     this.getReportStatus();
  }

  getReportStatus(){
this.getStatus.GetReportSubscriptionStatus().then((response) => {
          this.emailNotification=response.data.is_report_subscribed
        
        });
  }

  isOpened: boolean = false;

  triggerResize(){
    setTimeout(()=>window.dispatchEvent(new Event('resize')), 300);
  }

  changeRight(){
    this.getStatus.ChangeReportSubscriptionStatus(this.emailNotification).then((response)=>{
      
          this.emailNotification=response.data.is_report_subscribed
        
    })
  }

  logout() {
    this.auth.logout();
  }
}
